import { z } from "zod";
import { SetSimilarMachineRequestSchema } from "./machines.js";
import { SimOverrideSchema } from "./scenarios.js";
import { type CommandSpec, Uuid } from "./assistant-catalog-types.js";

// Família Config de relações da máquina (action · GESTOR). Configura relações
// máquina↔outra entidade via upsert idempotente: compatibilidade produto×máquina, máquina semelhante
// (referência de cold-start da simulação automática) e os parâmetros de SIMULAÇÃO de uma máquina
// dentro de um cenário. Reusa EXATAMENTE os services das telas (aba Compatibilidades / modal
// Máquina semelhante / autoria do sandbox) via dispatch. `lineId` viaja nos args só p/ invalidação.

export const CONFIG_COMMANDS: readonly CommandSpec[] = [
  {
    name: "machine.setCompatibility",
    kind: "action",
    riskTier: "confirm",
    minRole: "GESTOR",
    description:
      "Habilita (enabled=true) ou desabilita (enabled=false) a compatibilidade de um produto com uma máquina. Upsert idempotente — repetir o mesmo estado não gera erro.",
    argsSchema: z
      .object({ lineId: Uuid, machineId: Uuid, productId: Uuid, enabled: z.boolean() })
      .strict(),
  },
  {
    name: "machine.setSimilar",
    kind: "action",
    riskTier: "confirm",
    minRole: "GESTOR",
    description:
      "Define a máquina semelhante (referência de cold-start da simulação automática) de uma máquina. Passar similarMachineId=null limpa a referência.",
    argsSchema: SetSimilarMachineRequestSchema.extend({ lineId: Uuid, machineId: Uuid }).strict(),
  },
  {
    name: "scenario.setMachineSimParams",
    kind: "action",
    riskTier: "confirm",
    minRole: "GESTOR",
    description:
      "Ajusta os parâmetros de SIMULAÇÃO (feedRate/cycleTime/mtbf/mttr/quality) de uma máquina DENTRO de um cenário, como deltas percentuais (±25% por parâmetro). NÃO confundir com o parâmetro medido da máquina real — para apontar/editar esse, use parameter.* (família de apontamentos).",
    argsSchema: z
      .object({
        scenarioId: Uuid,
        machineId: Uuid,
        overrides: z.array(SimOverrideSchema).min(1).max(5),
      })
      .strict(),
  },
];
